import(/* webpackMode: "eager" */ "/home/web/talenzap/apps/frontend/web/src/app/global-error.tsx");
